module.exports = __webpack_public_path__ + "static/media/DINNextLTW23-Bold.6ed4e360.ttf";